import React from "react";

export const QuestionFive = () => {
  return <h1 className="questions-main-heading">Tell us about the delivery:</h1>;
};
